__webpack_require__.p = "/assets/components/headerfooter/uk/stwc/build/";